module.exports = __webpack_public_path__ + "public/img/logo.7352fe2a.png";